import { jsx as _jsx } from "react/jsx-runtime";
import { Button } from "@faire/web--source/slate/Button";
import { Row } from "@faire/web--source/slate/Layout";
import * as React from "react";
import styled from "styled-components";
export var RetrievalQueriesButton = function(param) {
    var onClick = param.onClick;
    // No need for translations as this is a tool only for internal Faire users
    return /*#__PURE__*/ _jsx(ButtonWrapper, {
        children: /*#__PURE__*/ _jsx(Button, {
            variant: "secondary",
            onClick: onClick,
            children: "Download Queries"
        })
    });
};
var ButtonWrapper = styled(Row).attrs({
    justify: "center"
}).withConfig({
    componentId: "sc-8a320652-0"
})([
    "width:100%;padding:5px;background-color:white;"
]);
